import * as React from 'react';

import { BookedOverlay } from '../NewbuildingTiledCarousel/BookedOverlay';
import * as styles from './styles.css';

export const NewbuildingBookedOverlay = () => {
  return (
    <div className={styles['container']}>
      <BookedOverlay />;
    </div>
  );
};
